<template>
  <UiAccordionNew class="cn-tips-section-accordion" :items="tabs">
    <template #header="{ item }">
      <span class="cn-tips-section-accordion__item-header">
        <UiIcon name="alert-circle" width="24" height="24" />
        <span>{{ item.title }}</span>
      </span>
    </template>
    <template #content="{ item }">
      <div class="cn-tips-section-accordion__item-content" v-html="item.text" />
    </template>
  </UiAccordionNew>
</template>

<script setup lang="ts">
import UiIcon from '@/components/ui/UiIcon';
import UiAccordionNew from '@/components/ui/UiAccordionNew';

interface Props {
  tabs: {
    title: string;
    text: string;
  }[];
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-tips-section-accordion {
  --ab-canyon-tips-section-accordion-item-header-colot-text-highlight: var(
    --ab-canyon-color-accent
  );
  --ab-canyon-tips-section-accordion-item-content-links-colot-text: var(
    --ab-canyon-color-dark
  );
  --ab-canyon-tips-section-accordion-item-content-links-colot-text-hover: var(
    --ab-canyon-color-accent
  );
  &.cn-accordion-new {
    --accordion__header_highlight-color: var(
      --ab-canyon-tips-section-accordion-item-header-colot-text-highlight
    );
  }
  &__item-header {
    line-height: 28px;
    font-size: 18px;
    align-items: center;
    display: flex;
    .cn-icon {
      margin-right: calc(var(--size-base) / 2);
    }
  }
  &__item-content {
    line-height: 22px;
    font-size: 16px;
    padding-top: var(--size-xl);
    a {
      color: var(
        --ab-canyon-tips-section-accordion-item-content-links-colot-text
      );
      text-decoration: underline;
      transition: color 0.2s;
      &:hover,
      &:focus {
        color: var(
          --ab-canyon-tips-section-accordion-item-content-links-colot-text-hover
        );
      }
    }
  }
}
</style>
